import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-bp.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-bp.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { MapService } from "../../../../../map/shared/map.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import Query from "@arcgis/core/rest/support/Query";
import { CreateApplicationLocationBpConstants } from "./create-application-location-bp.constants";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BehaviorSubject, debounceTime } from "rxjs";
import { PropertyBuildingHeadingEnumHeadingLookup } from "./property-building-heading.model";
import { AddBuildingComponent } from "./add-building/add-building.component";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { EditBuildingComponent } from "./edit-building/edit-building.component";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { finalize, take, takeUntil } from "rxjs/operators";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
let CreateApplicationLocationBpComponent = class CreateApplicationLocationBpComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    mapService;
    modalService;
    requestStatusService;
    changeDetectorRefs;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationBpConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationBpConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationBpConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationBpConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationBpConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationBpConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationBpConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationBpConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationBpConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationBpConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationBpConstants.ADDRESS_CONTROL;
    erfSizeControl = CreateApplicationLocationBpConstants.ERF_SIZE_CONTROL;
    titleDeedControl = CreateApplicationLocationBpConstants.TITLE_DEED_CONTROL;
    zoneControl = CreateApplicationLocationBpConstants.ZONE_CONTROL;
    ownerControl = CreateApplicationLocationBpConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationBpConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationBpConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationBpConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationBpConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationBpConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationBpConstants.ADDRESS_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = CreateApplicationLocationBpConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    titleDeedTextPlaceHolder = CreateApplicationLocationBpConstants.TITLE_DEED_TEXT_PLACEHOLDER;
    zoneLabel = CreateApplicationLocationBpConstants.ZONE_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addZoneLabel = CreateApplicationLocationBpConstants.ADD_ZONE_LABEL;
    ownerLabel = CreateApplicationLocationBpConstants.OWNER_LABEL;
    copyApplicantToOwnerZoneLabel = CreateApplicationLocationBpConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = CreateApplicationLocationBpConstants.REMOVE_PROPERTY_LABEL;
    propertyApplicationDetailsLabel = CreateApplicationLocationBpConstants.PROPERTY_APPLICATION_DETAILS_LABEL;
    buildingDetailsLabel = CreateApplicationLocationBpConstants.BUILDING_DETAILS_LABEL;
    mainBuildingLabel = CreateApplicationLocationBpConstants.MAIN_BUILDING_LABEL;
    outBuildingLabel = CreateApplicationLocationBpConstants.OUT_BUILING_LABEL;
    totalLabel = CreateApplicationLocationBpConstants.TOTAL_LABEL;
    stoepLabel = CreateApplicationLocationBpConstants.STOEP_LABEL;
    miscellaneous = CreateApplicationLocationBpConstants.MISCELLANEOUS_LABEL;
    propertyDescriptionControl = CreateApplicationLocationBpConstants.PROPERTY_DESCRIPTION_CONTROL;
    titleDeedRestrictionsControl = CreateApplicationLocationBpConstants.TITLE_DEED_RESTRICTION_CONTROL;
    externalWallsControl = CreateApplicationLocationBpConstants.EXTERNAL_WALLS_CONTROL;
    internalWallsControl = CreateApplicationLocationBpConstants.INTERNAL_WALLS_CONTROL;
    roofingControl = CreateApplicationLocationBpConstants.ROOFING_CONTROL;
    numberOfHousesUnitsControl = CreateApplicationLocationBpConstants.NUMBER_OF_HOUSES_UNITS_CONTROL;
    totalExistingControl = CreateApplicationLocationBpConstants.TOTAL_EXISTING_CONTROL;
    totalAddedControl = CreateApplicationLocationBpConstants.TOTAL_ADDED_CONTROL;
    totalFloorAreaControl = CreateApplicationLocationBpConstants.TOTAL_FLOOR_AREA_CONTROL;
    coveredExistingControl = CreateApplicationLocationBpConstants.COVERED_EXISTING_CONTROL;
    coveredAddedControl = CreateApplicationLocationBpConstants.COVERED_ADDED_CONTROL;
    openExistingControl = CreateApplicationLocationBpConstants.OPEN_EXISTING_CONTROL;
    openAddedControl = CreateApplicationLocationBpConstants.OPEN_ADDED_CONTROL;
    totalExistingPatioControl = CreateApplicationLocationBpConstants.TOTAL_EXISTING_PATIO_CONTROL;
    totalAddedPatioControl = CreateApplicationLocationBpConstants.TOTAL_ADDED_PATIO_CONTROL;
    poolControl = CreateApplicationLocationBpConstants.POOL_CONTROL;
    boundaryWallHeightControl = CreateApplicationLocationBpConstants.BOUNDARY_WALL_HEIGHT_CONTROL;
    boundaryWallRunningControl = CreateApplicationLocationBpConstants.BOUNDARY_WALL_RUNNING_CONTROL;
    coverageControl = CreateApplicationLocationBpConstants.COVERAGE_CONTROL;
    bulkCalculationControl = CreateApplicationLocationBpConstants.BULK_CALCULATION_CONTROL;
    propertyDescriptionTextPlaceHolder = CreateApplicationLocationBpConstants.PROPERTY_DESCRIPTION_LABEL;
    titleDeedRestrictionsTextPlaceHolder = CreateApplicationLocationBpConstants.TITLE_DEED_RESTRICTION_LABEL;
    externalWallsTextPlaceHolder = CreateApplicationLocationBpConstants.EXTERNAL_WALLS_LABEL;
    internalWallsTextPlaceHolder = CreateApplicationLocationBpConstants.INTERNAL_WALLS_LABEL;
    roofingTextPlaceHolder = CreateApplicationLocationBpConstants.ROOFING_LABEL;
    numberOfHousesUnitsTextPlaceHolder = CreateApplicationLocationBpConstants.NUMBER_OF_HOUSES_UNITS_LABEL;
    totalExistingPlaceHolder = CreateApplicationLocationBpConstants.TOTAL_EXISTING_LABEL;
    totalAddedTextPlaceHolder = CreateApplicationLocationBpConstants.TOTAL_ADDED_LABEL;
    totalFloorAreaTextPlaceHolder = CreateApplicationLocationBpConstants.TOTAL_FLOOR_AREA_LABEL;
    coveredExistingTextPlaceHolder = CreateApplicationLocationBpConstants.COVERED_EXISTING_LABEL;
    coveredAddedTextPlaceHolder = CreateApplicationLocationBpConstants.COVERED_ADDED_LABEL;
    openExistingTextPlaceHolder = CreateApplicationLocationBpConstants.OPEN_EXISTING_LABEL;
    openAddedTextPlaceHolder = CreateApplicationLocationBpConstants.OPEN_ADDED_LABEL;
    totalExistingPatioTextPlaceHolder = CreateApplicationLocationBpConstants.TOTAL_EXISTING_PATIO_LABEL;
    totalAddedPatioTextPlaceHolder = CreateApplicationLocationBpConstants.TOTAL_ADDED_PATIO_LABEL;
    poolTextPlaceHolder = CreateApplicationLocationBpConstants.POOL_LABEL;
    boundaryWallHeightTextPlaceHolder = CreateApplicationLocationBpConstants.BOUNDARY_WALL_HEIGHT_LABEL;
    boundaryWallRunningTextPlaceHolder = CreateApplicationLocationBpConstants.BOUNDARY_WALL_RUNNING_LABEL;
    coverageTextPlaceHolder = CreateApplicationLocationBpConstants.COVERAGE_LABEL;
    bulkCalculationTextPlaceHolder = CreateApplicationLocationBpConstants.BULK_CALCULATION_LABEL;
    calculationsLabel = CreateApplicationLocationBpConstants.CALCULATIONS_LABEL;
    propertiesHeading = CreateApplicationLocationBpConstants.PROPERTY_HEADING_LABEL;
    resubmissionMessage = CreateApplicationLocationBpConstants.RESUBMISSION_MESSAGE;
    selectedPropertySubscription;
    deleteLabel = SharedConstants.REMOVE_LABEL;
    editLabel = SharedConstants.EDIT_LABEL;
    addLabel = SharedConstants.ADD_LABEL;
    removeDialogTitle = CreateApplicationLocationBpConstants.REMOVE_DIALOG_TEXT;
    removeMainContent = `${SharedConstants.REMOVE_MESSAGE} main building(s)?`;
    removeOutContent = `${SharedConstants.REMOVE_MESSAGE} outbuilding(s)?`;
    selectPromptMessage = SharedConstants.NO_ITEM_SELECTED;
    selectOneDocMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerListLabel = "Owners";
    zoneOptions = [];
    externalWallsOptions = [];
    internalWallsOptions = [];
    roofingOptions = [];
    // @ts-ignore
    mainTableMapper;
    // @ts-ignore
    outTableMapper;
    mapComponent;
    modalOptions = {
        size: "lg",
        centered: true,
        keyboard: false,
        backdrop: "static"
    };
    isMapLoaded = false;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    showPropertyForm = false;
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, appController, mapService, modalService, requestStatusService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.mapService = mapService;
        this.modalService = modalService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initializeColumnToObjectMapping();
        this.initForm();
        if (this.appController.moduleSimulateMode) {
            const defaults = SimulationUtils.simulate_Create_Application();
            this.externalWallsOptions = defaults.externalWallsOptions;
            this.internalWallsOptions = defaults.internalWallsOptions;
            this.roofingOptions = defaults.roofingOptions;
            this.zoneOptions = defaults.zoneOptions;
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(defaults.simulateApplicantFilterGroupObjects);
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("externalWallsOptions")) {
                this.externalWallsOptions = this.aflaModuleStrategyService.lookups.get("externalWallsOptions");
                this.internalWallsOptions = this.aflaModuleStrategyService.lookups.get("internalWallsOptions");
                this.roofingOptions = this.aflaModuleStrategyService.lookups.get("roofingOptions");
                this.zoneOptions = this.aflaModuleStrategyService.lookups.get("zoneOptions");
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
        this.subscribeToProperty();
        if (this.createApplicationService.propertyData) {
            this.loadExistingProperty(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
        //this.startMetadataSubscription.unsubscribe();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
    }
    getProperties() {
        const propertyControl = this.propertiesForm.get("properties");
        if (propertyControl.length === 0) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(null, [Validators.required]),
                subdivision: new FormControl(null, [Validators.required]),
                allotment: new FormControl(null, [Validators.required]),
                farmNo: new FormControl(null, [Validators.required]),
                sgCode: new FormControl(null, [Validators.required]),
                address: new FormControl(null, [Validators.required]),
                erfSize: new FormControl(null, [Validators.required]),
                titleDeed: new FormControl(null, [Validators.required]),
                propertyDescription: new FormControl(null, [Validators.required]),
                titleDeedRestrictions: new FormControl(null, [Validators.required]),
                externalWalls: new FormControl(null, [Validators.required]),
                internalWalls: new FormControl(null, [Validators.required]),
                roofing: new FormControl(null, [Validators.required]),
                numberOfHousesUnits: new FormControl(null, [Validators.required]),
                totalExisting: new FormControl({ value: 0, disabled: true }),
                totalAdded: new FormControl({ value: 0, disabled: true }),
                totalFloorArea: new FormControl({ value: 0, disabled: true }),
                coveredExisting: new FormControl(0, [Validators.required]),
                coveredAdded: new FormControl(0, [Validators.required]),
                openExisting: new FormControl(0, [Validators.required]),
                openAdded: new FormControl(0, [Validators.required]),
                totalExistingPatio: new FormControl({ value: 0, disabled: true }),
                totalAddedPatio: new FormControl({ value: 0, disabled: true }),
                pool: new FormControl(0, [Validators.required]),
                boundaryWallHeight: new FormControl(0, [Validators.required]),
                boundaryWallRunning: new FormControl(0, [Validators.required]),
                coverage: new FormControl({ value: 0, disabled: true }),
                bulkCalculation: new FormControl({ value: 0, disabled: true }),
                geometry: new FormControl(null),
                centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1)]),
                owners: new FormControl(null, [Validators.required]),
                mainBuildings: new FormArray([]),
                outBuildings: new FormArray([]),
                mainTableDataSource: new FormControl(new BehaviorSubject([])),
                mainTableSelection: new FormControl([]),
                outTableDataSource: new FormControl(new BehaviorSubject([])),
                outTableSelection: new FormControl([]),
            });
            propertyControl.push(newProperty);
        }
        return propertyControl;
    }
    getZones() {
        const propertyControl = this.propertiesForm.get("properties");
        return propertyControl.controls[0].get("zones");
    }
    updateRequiredFields() {
        const propertyControlArray = this.propertiesForm.get("properties");
        const propertyControl = propertyControlArray.controls[0];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveZoneClicked(zoneIndex) {
        const controls = this.getZones();
        if (controls.controls.length > 1) {
            controls.removeAt(zoneIndex);
        }
    }
    onBtnAddZoneClicked() {
        const zonesControl = this.getZones();
        const zoneGroup = new FormGroup({
            zone: new FormControl(null, [Validators.required])
        });
        zonesControl.push(zoneGroup);
    }
    onBtnCopyApplicantToOwnerClicked() {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const propertyControl = this.propertiesForm.get("properties");
        const ownersFormControl = propertyControl.controls[0].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveMainClicked($event) {
        const propertyControl = this.propertiesForm.get("properties");
        let mainTableSelection = propertyControl.controls[0].get("mainTableSelection").value;
        const mainTableDataSource = propertyControl.controls[0].get("mainTableDataSource").value;
        if (mainTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        const deletedItem = mainTableSelection;
        let index = 0;
        const itemsAlreadyOnTable = mainTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === deletedItem) {
                index = i;
            }
        }
        const options = {
            size: "sm",
            centered: true,
            keyboard: false,
            backdrop: "static"
        };
        const title = this.removeDialogTitle;
        const contentMessage = this.removeMainContent;
        const dialogRef = this.modalService.open(PopUpComponent, options);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = index;
        dialogRef.result.then((deletedIndex) => {
            this.changeDetectorRefs.markForCheck();
            if (deletedIndex !== undefined && deletedIndex !== null) {
                itemsAlreadyOnTable.splice(deletedIndex, 1);
                const allItems = [...itemsAlreadyOnTable];
                mainTableDataSource.next(allItems);
                mainTableSelection = [];
                const propertyControl = this.propertiesForm.get("properties");
                propertyControl.controls[0].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch((res) => {
        });
    }
    onBtnEditMainClicked($event) {
        const propertyControl = this.propertiesForm.get("properties");
        let mainTableSelection = propertyControl.controls[0].get("mainTableSelection").value;
        const mainTableDataSource = propertyControl.controls[0].get("mainTableDataSource").value;
        if (mainTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        if (mainTableSelection.length > 1) {
            this.appController.showMessage(this.selectOneDocMessage, AlertType.Warning);
            return;
        }
        let index = 0;
        const itemsAlreadyOnTable = mainTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === mainTableSelection[0]) {
                index = i;
            }
        }
        const modalRef = this.modalService.open(EditBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Edit main building";
        modalRef.componentInstance.building = mainTableSelection[0];
        modalRef.componentInstance.editedIndex = index;
        modalRef.result.then((updatedbuilding) => {
            this.changeDetectorRefs.markForCheck();
            if (updatedbuilding) {
                itemsAlreadyOnTable[updatedbuilding[0]] = updatedbuilding[1];
                const allItems = [...itemsAlreadyOnTable];
                mainTableDataSource.next(allItems);
                mainTableSelection = [];
                const propertyControl = this.propertiesForm.get("properties");
                propertyControl.controls[0].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch((res) => {
        });
    }
    onBtnAddMainClicked($event) {
        const propertyControl = this.propertiesForm.get("properties");
        let mainTableSelection = propertyControl.controls[0].get("mainTableSelection").value;
        const mainTableDataSource = propertyControl.controls[0].get("mainTableDataSource").value;
        const modalRef = this.modalService.open(AddBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Add main building";
        modalRef.componentInstance.type = "Main Building";
        modalRef.result.then(newBuilding => {
            if (newBuilding) {
                const itemsAlreadyOnTable = mainTableDataSource.getValue();
                const allItems = [...itemsAlreadyOnTable, newBuilding];
                mainTableDataSource.next(allItems);
                mainTableSelection = [];
                propertyControl.controls[0].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch((res) => {
        });
    }
    onBtnRemoveOutClicked($event) {
        const propertyControl = this.propertiesForm.get("properties");
        let outTableSelection = propertyControl.controls[0].get("outTableSelection").value;
        const outTableDataSource = propertyControl.controls[0].get("outTableDataSource").value;
        if (outTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        const deletedItem = outTableSelection;
        let index = 0;
        const itemsAlreadyOnTable = outTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === deletedItem) {
                index = i;
            }
        }
        const options = {
            size: "sm",
            centered: true,
            keyboard: false,
            backdrop: "static"
        };
        const title = this.removeDialogTitle;
        const contentMessage = this.removeOutContent;
        const dialogRef = this.modalService.open(PopUpComponent, options);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = index;
        dialogRef.result.then((deletedIndex) => {
            this.changeDetectorRefs.markForCheck();
            if (deletedIndex !== undefined && deletedIndex !== null) {
                itemsAlreadyOnTable.splice(deletedIndex, 1);
                const allItems = [...itemsAlreadyOnTable];
                outTableDataSource.next(allItems);
                outTableSelection = [];
                propertyControl.controls[0].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch((res) => {
        });
    }
    onBtnEditOutClicked($event) {
        const propertyControl = this.propertiesForm.get("properties");
        let outTableSelection = propertyControl.controls[0].get("outTableSelection").value;
        const outTableDataSource = propertyControl.controls[0].get("outTableDataSource").value;
        if (outTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        if (outTableSelection.length > 1) {
            this.appController.showMessage(this.selectOneDocMessage, AlertType.Warning);
            return;
        }
        let index = 0;
        const itemsAlreadyOnTable = outTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === outTableSelection[0]) {
                index = i;
            }
        }
        const modalRef = this.modalService.open(EditBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Edit outbuilding";
        modalRef.componentInstance.building = outTableSelection[0];
        modalRef.componentInstance.editedIndex = index;
        modalRef.result.then((updatedBuilding) => {
            this.changeDetectorRefs.markForCheck();
            if (updatedBuilding) {
                itemsAlreadyOnTable[updatedBuilding[0]] = updatedBuilding[1];
                const allItems = [...itemsAlreadyOnTable];
                outTableDataSource.next(allItems);
                outTableSelection = [];
                propertyControl.controls[0].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch((res) => {
        });
    }
    onBtnAddOutClicked($event) {
        const propertyControl = this.propertiesForm.get("properties");
        let outTableSelection = propertyControl.controls[0].get("outTableSelection").value;
        const outTableDataSource = propertyControl.controls[0].get("outTableDataSource").value;
        const modalRef = this.modalService.open(AddBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Add outbuilding";
        modalRef.componentInstance.type = "Additional building";
        modalRef.result.then(newBuilding => {
            if (newBuilding) {
                const itemsAlreadyOnTable = outTableDataSource.getValue();
                const allItems = [...itemsAlreadyOnTable, newBuilding];
                outTableDataSource.next(allItems);
                outTableSelection = [];
                propertyControl.controls[0].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch((res) => {
        });
    }
    mainArrayReturned(array, index) {
        const propertyControl = this.propertiesForm.get("properties");
        propertyControl.controls[index].get("mainTableSelection").setValue(array);
    }
    outArrayReturned(array, index) {
        const propertyControl = this.propertiesForm.get("properties");
        propertyControl.controls[index].get("outTableSelection").setValue(array);
    }
    syncMainBuildings() {
        const propertyControl = this.propertiesForm.get("properties");
        propertyControl.controls.forEach(property => {
            const items = property.get("mainTableDataSource").value.getValue();
            const formItems = property.get("mainBuildings");
            formItems.clear();
            items.forEach(item => {
                const newItem = new FormGroup({
                    floor: new FormControl(item.floor),
                    existingSize: new FormControl(item.existingSize),
                    addedSize: new FormControl(item.addedSize),
                    buildingNameNumber: new FormControl(item.buildingNameNumber)
                });
                formItems.push(newItem);
            });
        });
        this.calculateTotals();
    }
    syncOutBuildings() {
        const propertyControl = this.propertiesForm.get("properties");
        propertyControl.controls.forEach(property => {
            const items = property.get("outTableDataSource").value.getValue();
            const formItems = property.get("outBuildings");
            formItems.clear();
            items.forEach(item => {
                const newItem = new FormGroup({
                    floor: new FormControl(item.floor),
                    existingSize: new FormControl(item.existingSize),
                    addedSize: new FormControl(item.addedSize),
                    buildingNameNumber: new FormControl(item.buildingNameNumber)
                });
                formItems.push(newItem);
            });
        });
        this.calculateTotals();
    }
    calculateTotals() {
        const propertyControl = this.propertiesForm.get("properties");
        const properties = propertyControl.controls;
        properties.forEach(property => {
            property.get("coverage").setValue(0);
            property.get("bulkCalculation").setValue(0);
            let totalExistingPatioCalculated = 0.00;
            let totalAddedPatioCalculated = 0.00;
            let totalExistingCalculated = 0.00;
            let totalAddedCalculated = 0.00;
            let totalFloorCalculated = 0.00;
            let totalGroundFloorCalculated = 0.00;
            try {
                if (property.get("coveredExisting").value !== null && property.get("coveredAdded").value !== null &&
                    property.get("openExisting").value !== null && property.get("openAdded").value !== null) {
                    const patioCoverageExisting = property.get("coveredExisting").value;
                    const patioCoverageAdded = property.get("coveredAdded").value;
                    const patioOpenExisting = property.get("openExisting").value;
                    const patioOpenAdded = property.get("openAdded").value;
                    totalExistingPatioCalculated += patioCoverageExisting + patioOpenExisting;
                    totalAddedPatioCalculated += patioCoverageAdded + patioOpenAdded;
                    property.get("totalExistingPatio").setValue(totalExistingPatioCalculated);
                    property.get("totalAddedPatio").setValue(totalAddedPatioCalculated);
                }
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
            try {
                const mainBuildings = property.get("mainBuildings");
                const outbuildings = property.get("outBuildings");
                mainBuildings.controls.forEach(building => {
                    totalExistingCalculated += building.get("existingSize").value;
                    totalAddedCalculated += building.get("addedSize").value;
                    if (building.get("floor").value === 0) {
                        totalGroundFloorCalculated += building.get("existingSize").value;
                        totalGroundFloorCalculated += building.get("addedSize").value;
                    }
                });
                outbuildings.controls.forEach(building => {
                    totalExistingCalculated += building.get("existingSize").value;
                    totalAddedCalculated += building.get("addedSize").value;
                    if (building.get("floor").value === 0) {
                        totalGroundFloorCalculated += building.get("existingSize").value;
                        totalGroundFloorCalculated += building.get("addedSize").value;
                    }
                });
                totalFloorCalculated = totalAddedCalculated + totalExistingCalculated;
                property.get("totalExisting").setValue(totalExistingCalculated);
                property.get("totalAdded").setValue(totalAddedCalculated);
                property.get("totalFloorArea").setValue(totalFloorCalculated);
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
            try {
                if (property.get("coveredExisting").value !== null && property.get("coveredAdded").value !== null && property.get("erfSize").value !== null) {
                    const patioCoverageExisting = property.get("coveredExisting").value;
                    const patioCoverageAdded = property.get("coveredAdded").value;
                    const totalCoveredPatio = 0.00 + patioCoverageExisting + patioCoverageAdded;
                    const totalCoveredArea = 0.00 + totalExistingCalculated + totalAddedCalculated + totalCoveredPatio;
                    const totalFloorArea = 0.00 + totalGroundFloorCalculated + totalCoveredPatio;
                    const totalArea = 0.00 + property.get("erfSize").value;
                    const bulkCalculation = totalCoveredArea / totalArea;
                    const covered = totalFloorArea / totalArea * 100;
                    property.get("coverage").setValue(Math.round(covered * 100) / 100);
                    property.get("bulkCalculation").setValue(Math.round(bulkCalculation * 100) / 100);
                }
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
        });
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
        const propertyControl = this.propertiesForm.get("properties");
        if (propertyControl.length === 0) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(null, [Validators.required]),
                subdivision: new FormControl(null, [Validators.required]),
                allotment: new FormControl(null, [Validators.required]),
                farmNo: new FormControl(null, [Validators.required]),
                sgCode: new FormControl(null, [Validators.required]),
                address: new FormControl(null, [Validators.required]),
                erfSize: new FormControl(null, [Validators.required]),
                titleDeed: new FormControl(null, [Validators.required]),
                propertyDescription: new FormControl(null, [Validators.required]),
                titleDeedRestrictions: new FormControl(null, [Validators.required]),
                externalWalls: new FormControl(null, [Validators.required]),
                internalWalls: new FormControl(null, [Validators.required]),
                roofing: new FormControl(null, [Validators.required]),
                numberOfHousesUnits: new FormControl(null, [Validators.required]),
                totalExisting: new FormControl({ value: 0, disabled: true }),
                totalAdded: new FormControl({ value: 0, disabled: true }),
                totalFloorArea: new FormControl({ value: 0, disabled: true }),
                coveredExisting: new FormControl(0, [Validators.required]),
                coveredAdded: new FormControl(0, [Validators.required]),
                openExisting: new FormControl(0, [Validators.required]),
                openAdded: new FormControl(0, [Validators.required]),
                totalExistingPatio: new FormControl({ value: 0, disabled: true }),
                totalAddedPatio: new FormControl({ value: 0, disabled: true }),
                pool: new FormControl(0, [Validators.required]),
                boundaryWallHeight: new FormControl(0, [Validators.required]),
                boundaryWallRunning: new FormControl(0, [Validators.required]),
                coverage: new FormControl({ value: 0, disabled: true }),
                bulkCalculation: new FormControl({ value: 0, disabled: true }),
                geometry: new FormControl(null),
                centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1)]),
                owners: new FormControl(null, [Validators.required]),
                mainBuildings: new FormArray([]),
                outBuildings: new FormArray([]),
                mainTableDataSource: new FormControl(new BehaviorSubject([])),
                mainTableSelection: new FormControl([]),
                outTableDataSource: new FormControl(new BehaviorSubject([])),
                outTableSelection: new FormControl([]),
            });
            propertyControl.push(newProperty);
        }
        const firstProperty = propertyControl.controls[0];
        if (firstProperty && firstProperty.get("geometry")?.value) {
            this.showPropertyForm = true;
        }
        else {
            this.showPropertyForm = false;
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and (name eq 'PropertyRoofing' or name eq 'PropertyExternalWalls' or name eq 'PropertyInternalWalls' or name eq 'Zoning')`,
        };
        this.createApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationBpConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const externalWalls = [];
        const internalWalls = [];
        const roofings = [];
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "PropertyRoofing") {
                    roofings.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyExternalWalls") {
                    externalWalls.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyInternalWalls") {
                    internalWalls.push(JSON.parse(item.content));
                }
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("zoneOptions", zones);
        this.zoneOptions = zones;
        this.aflaModuleStrategyService.lookups.set("externalWallsOptions", externalWalls);
        this.externalWallsOptions = externalWalls;
        this.aflaModuleStrategyService.lookups.set("internalWallsOptions", internalWalls);
        this.internalWallsOptions = internalWalls;
        this.aflaModuleStrategyService.lookups.set("roofingOptions", roofings);
        this.roofingOptions = roofings;
        this.changeDetectorRefs.detectChanges();
    }
    loadExistingProperty(property) {
        const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
        const geom = JsonUtils.fromJSON(geometryArc);
        this.getPreviousApplicantData(property, geom);
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        const propertiesFormArray = this.propertiesForm.get("properties");
        propertiesFormArray.clear();
        // TODO: build a lookup map for mapping the propertyData layer to the data for Property
        const newProperty = new FormGroup({
            erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
            subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
            allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
            farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
            sgCode: new FormControl(sgCode, [Validators.required]),
            address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
            erfSize: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfSize", "erfsize"), [Validators.required]),
            titleDeed: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TitleDeed, titledeed"), [Validators.required]),
            propertyDescription: new FormControl(null, [Validators.required]),
            titleDeedRestrictions: new FormControl(null, [Validators.required]),
            externalWalls: new FormControl(null, [Validators.required]),
            internalWalls: new FormControl(null, [Validators.required]),
            roofing: new FormControl(null, [Validators.required]),
            numberOfHousesUnits: new FormControl(null, [Validators.required]),
            totalExisting: new FormControl({ value: 0, disabled: true }),
            totalAdded: new FormControl({ value: 0, disabled: true }),
            totalFloorArea: new FormControl({ value: 0, disabled: true }),
            coveredExisting: new FormControl(0, [Validators.required]),
            coveredAdded: new FormControl(0, [Validators.required]),
            openExisting: new FormControl(0, [Validators.required]),
            openAdded: new FormControl(0, [Validators.required]),
            totalExistingPatio: new FormControl({ value: 0, disabled: true }),
            totalAddedPatio: new FormControl({ value: 0, disabled: true }),
            pool: new FormControl(0, [Validators.required]),
            boundaryWallHeight: new FormControl(0, [Validators.required]),
            boundaryWallRunning: new FormControl(0, [Validators.required]),
            coverage: new FormControl({ value: 0, disabled: true }),
            bulkCalculation: new FormControl({ value: 0, disabled: true }),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required]),
            zones: new FormArray([], [Validators.min(1)]),
            owners: new FormControl(null, [Validators.required]),
            mainBuildings: new FormArray([]),
            outBuildings: new FormArray([]),
            mainTableDataSource: new FormControl(new BehaviorSubject([])),
            mainTableSelection: new FormControl([]),
            outTableDataSource: new FormControl(new BehaviorSubject([])),
            outTableSelection: new FormControl([]),
        });
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometry));
        this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
            .subscribe({
            next: (trueCentroidResponse) => {
                newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                const zonesControl = newProperty.get("zones");
                const zoningLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property zone");
                if (zoningLayerObj !== undefined && zoningLayerObj !== null) {
                    const zoningLayer = zoningLayerObj.layer;
                    const zoningQuery = new Query();
                    zoningQuery.where = `SgCode = '${sgCode}'`;
                    zoningQuery.returnGeometry = false;
                    zoningQuery.outFields = ["*"];
                    zoningLayer.queryFeatures(zoningQuery).then((zoneFeatureSet) => {
                        // Make sure the grave centroid is within one cemetery boundary
                        if (zoneFeatureSet.features.length > 0) {
                            zoneFeatureSet.features.forEach(item => {
                                const zone = this.propertyDataAlternateColumnName(item.attributes, "Zoning", "zoning");
                                if (zone !== undefined && zone !== null) {
                                    let foundZone = null;
                                    this.zoneOptions.forEach(zoneItem => {
                                        if (zoneItem.value === zone) {
                                            foundZone = zoneItem;
                                        }
                                    });
                                    if (zonesControl.length === 0) {
                                        zonesControl.push(new FormGroup({
                                            zone: new FormControl(foundZone, [Validators.required])
                                        }));
                                    }
                                    else {
                                        this.appController.showMessage(CreateApplicationLocationBpConstants.ZONING_NOT_FOUND.replace("{0}", zone), AlertType.Error);
                                        const params = {
                                            moduleId: this.createApplicationService.moduleID, lookupType: "Zoning", lookupList: [zone]
                                        };
                                        this.createApplicationService.sendMissingLookupsEmail(params).subscribe();
                                    }
                                }
                                else {
                                    this.appController.showMessage(CreateApplicationLocationBpConstants.INVALID_ZONING_ATTRIBUTE, AlertType.Error);
                                }
                            });
                        }
                        if (zonesControl.length === 0) {
                            zonesControl.push(new FormGroup({
                                zone: new FormControl(null, [Validators.required])
                            }));
                        }
                        this.getPropertyOwners(sgCode, newProperty);
                    }, (zoningError) => {
                        this.appController.showMessage(zoningError.message, AlertType.Error);
                        this.getPropertyOwners(sgCode, newProperty);
                    });
                }
                else {
                    if (zonesControl.length === 0) {
                        zonesControl.push(new FormGroup({
                            zone: new FormControl(null, [Validators.required])
                        }));
                    }
                    this.getPropertyOwners(sgCode, newProperty);
                }
            },
            error: (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.handleServerErrorMessage(CreateApplicationLocationBpConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                name: item.attributes.Name ? item.attributes.Name : item.attributes.name,
                                surname: item.attributes.Surname ? item.attributes.Surname : item.attributes.surname,
                                telephone: item.attributes.Telephone ? item.attributes.Telephone : item.attributes.telephone,
                                email: item.attributes.Email ? item.attributes.Email : item.attributes.email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod ? item.attributes.DefaultCommunicationMethod : item.attributes.defaultcommunicationmethod,
                                postalAddress: item.attributes.PostalAddress ? item.attributes.PostalAddress : item.attributes.postaladdress,
                                designation: item.attributes.Designation ? item.attributes.Designation : item.attributes.designation,
                                organisation: item.attributes.Organisation ? item.attributes.Organisation : item.attributes.organisation,
                                clientVatNumber: item.attributes.ClientVatNumber ? item.attributes.ClientVatNumber : item.attributes.clientvatnumber,
                                streetAddress: item.attributes.StreetAddress ? item.attributes.StreetAddress : item.attributes.streetaddress,
                                homePhone: item.attributes.Homephone ? item.attributes.Homephone : item.attributes.homephone,
                                idNumber: item.attributes.IDNumber ? item.attributes.IDNumber : item.attributes.idnumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber ? item.attributes.OrganisationRegistrationNumber : item.attributes.organisationregistrationnumber,
                                representative: item.attributes.Representative ? item.attributes.Representative : item.attributes.representative,
                                fax: item.attributes.Fax ? item.attributes.Fax : item.attributes.fax,
                                cellphone: item.attributes.Cellphone ? item.attributes.Cellphone : item.attributes.cellphone,
                                streetSuburb: item.attributes.StreetSuburb ? item.attributes.StreetSuburb : item.attributes.streetsuburb,
                                streetCity: item.attributes.StreetCity ? item.attributes.StreetCity : item.attributes.streetcity,
                                streetProvince: item.attributes.StreetProvince ? item.attributes.StreetProvince : item.attributes.streetprovince,
                                streetCode: item.attributes.StreetCode ? item.attributes.StreetCode : item.attributes.streetcode,
                                postalSuburb: item.attributes.PostalSuburb ? item.attributes.PostalSuburb : item.attributes.postalsuburb,
                                postalCity: item.attributes.PostalCity ? item.attributes.PostalCity : item.attributes.postalcity,
                                postalProvince: item.attributes.PostalProvince ? item.attributes.PostalProvince : item.attributes.postalprovince,
                                postalCode: item.attributes.PostalCode ? item.attributes.PostalCode : item.attributes.postalcode,
                                postalCountry: item.attributes.PostalCountry ? item.attributes.PostalCountry : item.attributes.postalcountry,
                                streetCountry: item.attributes.StreetCountry ? item.attributes.StreetCountry : item.attributes.streetcountry,
                                professionalBody: item.attributes.ProfessionalBody ? item.attributes.ProfessionalBody : item.attributes.professionalbody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber ? item.attributes.ProfessionalBodyRegistrationNumber : item.attributes.professionalbodyregistrationumber,
                                groups: []
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(CreateApplicationLocationBpConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                const propertyControl = this.propertiesForm.get("properties");
                propertyControl.push(newProperty);
                this.updateRequiredFields();
                this.changeDetectorRefs.detectChanges();
                if (owners.length > 0) {
                    this.recipientListService.setRecipients(owners, true, ownersControl);
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            const propertyControl = this.propertiesForm.get("properties");
            propertyControl.push(newProperty);
            this.updateRequiredFields();
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    syncMapGeometries() {
        const geometries = [];
        const propertyControl = this.propertiesForm.get("properties");
        propertyControl.controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Building plans graphics", true);
            this.changeDetectorRefs.detectChanges();
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    subscribeToProperty() {
        if (this.aflaModuleStrategyService.previousApplication !== null) {
            this.appController.showMessage(this.resubmissionMessage, AlertType.Warning);
            return;
        }
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).pipe(takeUntil(this._destroy$)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
                //this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    initializeColumnToObjectMapping() {
        this.mainTableMapper = PropertyBuildingHeadingEnumHeadingLookup;
        this.outTableMapper = PropertyBuildingHeadingEnumHeadingLookup;
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        if (this.aflaModuleStrategyService.form.get("detailsForm").get("isResubmission").value === true) {
            this.appController.showMessage(this.resubmissionMessage, AlertType.Warning);
            return;
        }
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControlArray = this.propertiesForm.get("properties");
        const propertyControl = propertyControlArray.controls[0];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        this.showPropertyForm = true;
        if ((erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") || (farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "")) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    propertyControlArray.clear();
                    this.mapComponent.clearGraphics("Building plans graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    getPreviousApplicantData(property, geom) {
        const propertyControl = this.propertiesForm.get("properties");
        propertyControl.clear();
        const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
        const newProperty = new FormGroup({
            property: new FormControl(property),
            erfNo: new FormControl(property.erfNumber, [Validators.required]),
            subdivision: new FormControl(property.subdivision, [Validators.required]),
            allotment: new FormControl(property.allotment, [Validators.required]),
            farmNo: new FormControl(property.farmNumber, [Validators.required]),
            sgCode: new FormControl(property.sgCode, [Validators.required]),
            address: new FormControl(property.address, [Validators.required]),
            erfSize: new FormControl(property.erfSize, [Validators.required]),
            titleDeed: new FormControl(property.titleDeed, [Validators.required]),
            geometry: new FormControl(geom),
            centroid: new FormControl(null, [Validators.required]),
            zones: new FormArray([], [Validators.min(1)]),
            owners: new FormControl({ recipients: [] }, [Validators.required]),
            propertyDescription: new FormControl(property.applicationDescription, [Validators.required]),
            titleDeedRestrictions: new FormControl(property.applicationRestrictions, [Validators.required]),
            externalWalls: new FormControl(property.externalWalls, [Validators.required]),
            internalWalls: new FormControl(property.internalWalls, [Validators.required]),
            roofing: new FormControl(property.roofing, [Validators.required]),
            numberOfHousesUnits: new FormControl(property.numberOfHouses, [Validators.required]),
            totalExisting: new FormControl({ value: 0, disabled: true }),
            totalAdded: new FormControl({ value: 0, disabled: true }),
            totalFloorArea: new FormControl({ value: 0, disabled: true }),
            coveredExisting: new FormControl(property.patioCoveredExisting, [Validators.required]),
            coveredAdded: new FormControl(property.patioCoveredAdded, [Validators.required]),
            openExisting: new FormControl(property.patioOpenExisting, [Validators.required]),
            openAdded: new FormControl(property.patioOpenAdded, [Validators.required]),
            totalExistingPatio: new FormControl({ value: 0, disabled: true }),
            totalAddedPatio: new FormControl({ value: 0, disabled: true }),
            pool: new FormControl(property.pool, [Validators.required]),
            boundaryWallHeight: new FormControl(property.boundaryWallHeight, [Validators.required]),
            boundaryWallRunning: new FormControl(property.boundaryWallRunning, [Validators.required]),
            coverage: new FormControl({ value: property.coverage, disabled: true }),
            bulkCalculation: new FormControl({ value: property.bulkCalculation, disabled: true }),
            mainBuildings: new FormArray([]),
            outBuildings: new FormArray([]),
            mainTableDataSource: new FormControl(new BehaviorSubject([])),
            mainTableSelection: new FormControl([]),
            outTableDataSource: new FormControl(new BehaviorSubject([])),
            outTableSelection: new FormControl([]),
        });
        newProperty.controls.sgCode.disable();
        newProperty.controls.erfNo.disable();
        newProperty.controls.farmNo.disable();
        newProperty.controls.subdivision.disable();
        newProperty.controls.allotment.disable();
        const mainTableDataSource = newProperty.get("mainTableDataSource").value;
        const outTableDataSource = newProperty.get("outTableDataSource").value;
        const mainItems = [];
        const outItems = [];
        property.buildings.forEach(building => {
            if (building.type === "Main Building") {
                mainItems.push(building);
            }
            else {
                outItems.push(building);
            }
        });
        mainTableDataSource.next(mainItems);
        outTableDataSource.next(outItems);
        const zonesControl = newProperty.get("zones");
        property.zonings.forEach(zone => {
            this.zoneOptions.forEach(zoneOption => {
                if (zoneOption.value === zone.zoning) {
                    const zoneGroup = new FormGroup({
                        id: new FormControl(zone.id),
                        applicationId: new FormControl(zone.applicationId),
                        applicationPropertyId: new FormControl(zone.applicationPropertyId),
                        zone: new FormControl(zoneOption, [Validators.required]),
                        deleted: new FormControl(zone.deleted)
                    });
                    zonesControl.push(zoneGroup);
                }
            });
        });
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        const getTrueCentroid = this.createApplicationService.getTrueCentroid(url, formData).pipe(takeUntil(this._destroy$), take(1)).pipe(finalize(() => {
            getTrueCentroid.unsubscribe();
        })).subscribe({
            next: (response) => {
                newProperty.get("centroid").setValue(response.results[0].value);
                propertyControl.push(newProperty);
                this.changeDetectorRefs.detectChanges();
                const ownersControl = newProperty.get("owners");
                this.recipientListService.setRecipients(property.owners, false, ownersControl);
                this.updateRequiredFields();
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
                this.syncOutBuildings();
                this.calculateTotals();
                let externalWalls = null;
                this.externalWallsOptions.forEach(item => {
                    if (item.value === property.externalWalls) {
                        externalWalls = item;
                    }
                });
                let internalWalls = null;
                this.internalWallsOptions.forEach(item => {
                    if (item.value === property.internalWalls) {
                        internalWalls = item;
                    }
                });
                let roofing = null;
                this.roofingOptions.forEach(item => {
                    if (item.value === property.roofing) {
                        roofing = item;
                    }
                });
                newProperty.get("externalWalls").setValue(externalWalls);
                newProperty.get("internalWalls").setValue(internalWalls);
                newProperty.get("roofing").setValue(roofing);
                this.showPropertyForm = true;
                this.changeDetectorRefs.detectChanges();
                if (this.isMapLoaded) {
                    this.syncMapGeometries();
                }
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationBpConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: MapService },
        { type: NgbModal },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationBpComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-location-bp",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationBpComponent);
export { CreateApplicationLocationBpComponent };
